<template>
  <v-container fluid style="height: 100%" class="pa-0">
    <v-container fluid v-if="hasLoadingError" class="fill-height">
      <Error />
    </v-container>

    <v-container fluid v-else class="pa-0">
      <!--      <v-row>
        <v-col class="text-start">
          <span class="textLight&#45;&#45;text font-weight-medium text-h5">
            {{ $t("user.subRoles.subRoles") }}
          </span>
        </v-col>
      </v-row>-->

      <v-row>
        <v-col>
          <v-row justify="end">
            <v-col v-if="havePermissionCreateSubRole" cols="12" sm="6" md="3">
              <v-btn
                depressed
                min-height="45"
                block
                color="primary"
                style="text-transform: unset"
                class="rounded-lg font-weight-normal"
                @click="createSubRole"
              >
                <v-icon left> mdi-plus </v-icon>
                {{ $t("user.subRoles.addNewRole") }}
              </v-btn>
            </v-col>

            <v-col cols="5" v-if="$vuetify.breakpoint.mdAndUp"></v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="7">
              <SubRoleList
                :assignable-permissions="assignablePermissions"
                :sub-roles="subRoles"
                :loading="loading"
                @reFetch="reFetch"
                @editSubRoleVal="editSubRoleVal"
                @responseErr="errResponse"
              />
            </v-col>

            <v-col
              cols="12"
              md="5"
              :order="$vuetify.breakpoint.smAndDown ? 'first' : 'last'"
            >
              <create-or-edit-sub-role
                v-if="subRoleCreateOrEditCard"
                :isCreate="isCreate"
                :subRoleData="editData"
                :permissionsArr="assignablePermissions"
                :assignable-organization-permissions="
                  assignableOrganizationPermissions
                "
                @close="closeCreateOrUpdateComp"
                @afterCreate="reFetch"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar v-model="snackbarSuccess" timeout="3000" color="success">
      {{
        snackbarSuccessMessage || $t("course.courseDetails.successfullySave")
      }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbarSuccess = false"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbarError = false"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Error from "@/app/core-module/components/Error";
import SubRoleList from "@/app/user-module/components/SubRoleList";
import CreateOrEditSubRole from "./CreateOrEditSubRole.vue";

import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  name: "SubRoles",
  components: { Error, SubRoleList, CreateOrEditSubRole },
  data() {
    return {
      loading: true,
      hasLoadingError: false,
      assignablePermissions: [],
      assignableOrganizationPermissions: [],
      subRoles: [],
      totalCount: null,
      snackbarSuccess: false,
      snackbarError: false,
      subRoleCreateOrEditCard: false,
      isCreate: false,
      editData: {},
      snackbarSuccessMessage: null,
      snackbarErrorMessage: null,
    };
  },
  computed: {
    havePermissionCreateSubRole() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_SUB_ROLE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  apollo: {
    getSubRoles() {
      return {
        query: require("../api/query/getSubRoles.gql"),
        variables: { limit: 0, skip: 0 },
        result({ data, loading }) {
          if (data?.getSubRoles) {
            this.assignablePermissions = data.getSubRoles.assignablePermissions;
            this.assignableOrganizationPermissions =
              data.getSubRoles.assignableOrganizationPermissions;
            this.subRoles = data.getSubRoles.subRoles;
            this.totalCount = data.getSubRoles.totalCount;
          } else {
            this.hasLoadingError = true;
          }

          this.loading = loading;
        },
      };
    },
  },
  methods: {
    createSubRole() {
      this.editData = {};
      this.isCreate = true;
      this.subRoleCreateOrEditCard = true;
    },
    editSubRoleVal(val) {
      if (val) {
        this.editData = val;
        this.isCreate = false;
        this.subRoleCreateOrEditCard = true;
      }
    },
    closeCreateOrUpdateComp() {
      this.subRoleCreateOrEditCard = false;
    },
    reFetch() {
      this.$apollo.queries.getSubRoles.refetch();
      this.closeCreateOrUpdateComp();
    },
    errResponse(msg) {
      if (msg) this.snackbarErrorMessage = msg;
      this.snackbarError = true;
    },
  },
};
</script>
